import { render, staticRenderFns } from "./VehicleStatusChip.vue?vue&type=template&id=241cb4fe"
import script from "./VehicleStatusChip.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleStatusChip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports